import Pagination from '@material-ui/lab/Pagination';
import React, { ChangeEvent, FC } from 'react';
import { useTranslation } from 'react-i18next';
import GcpBox from '../gcp-box';
import GcpTypography from '../gcp-typography';

interface GcpClientPaginationProps {
  total: number;
  page: number;
  rowsPerPage: number;
  handleChangePage: (event: ChangeEvent<unknown>, newPage: number) => void;
}

const GcpClientPagination: FC<GcpClientPaginationProps> = (props) => {
  const { total, page, handleChangePage, rowsPerPage } = props;
  const { t } = useTranslation();

  return (
    <GcpBox display="flex" gap={2} justifyContent="flex-end" mb={4} mt={4}>
      <GcpBox alignItems="center" display="flex">
        <GcpTypography variant="body1">
          {t('transaction_list.viewing', {
            start: page * rowsPerPage + 1,
            end: Math.min(page * rowsPerPage + rowsPerPage, total),
            total,
          })}
        </GcpTypography>
      </GcpBox>
      <Pagination
        color="primary"
        count={Math.ceil(total / 20)}
        shape="rounded"
        variant="outlined"
        onChange={handleChangePage}
      />
    </GcpBox>
  );
};

export default GcpClientPagination;
